module.exports = __webpack_public_path__ + "static/media/1009847.45b66450.jpg";